/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import omit from "lodash/fp/omit";

import ApiCaller from "~/api/ApiCaller";
import {
  GetInfoResponse,
  PostLoginPayload,
  PostSend2FAEmailPayload,
  PostValidate2FATokenPayload,
} from "~/features/auth/types";
import { WebserviceResponse } from "~/types";

const AuthApi = {
  postLogin: (payload: PostLoginPayload) => {
    return ApiCaller.post("/v1/auth/login", omit("recaptchaToken", payload), {
      headers: {
        ["x-recaptcha-token"]: payload.recaptchaToken,
      },
    });
  },
  getInfo: () => {
    const url = "/v1/reseller/info";

    return ApiCaller.get<GetInfoResponse>(url);
  },
  postLogout: () => {
    const url = "/v1/auth/logout";

    return ApiCaller.post(url);
  },

  postValidate2FAToken: (data: PostValidate2FATokenPayload) =>
    ApiCaller.post<WebserviceResponse<string>>("/v1/twofactorauth/validatetoken", data),
  postSend2FAEmail: (data: PostSend2FAEmailPayload) =>
    ApiCaller.post<WebserviceResponse<{ email: string }>>("/v1/twofactorauth/sendemail", data),
  getCheck2FASession: () => ApiCaller.get("/v1/twofactorauth/checksession"),
};

export default AuthApi;
